/**
 * Where the portal gets its gateway credentials.
 *
 * Both values were string literals in `App.tsx` until 2026-09-15. The base URL being there was
 * untidy; the API key being there was a disclosure. It was committed, so it is in this
 * repository's history and readable by anyone who has ever had access, and it shipped inside the
 * JavaScript bundle of every build — where it is readable by anyone at all.
 *
 * The bundle part does not change and cannot: this is a browser application, so whatever key it
 * holds is public by construction, which is why the gateway issues it a key of kind `Public`
 * scoped to exactly three operations — read a client, list vacancies, submit an application. The
 * scope set is the boundary, not the key.
 *
 * What does change is that the value is now a build input rather than source. It can be rotated by
 * rebuilding instead of by editing code, it is not in the git history of this repository, and a
 * different environment can hold a different key.
 *
 * Create React App inlines `REACT_APP_*` at build time, so these are read once, here, rather than
 * scattered through the components — and a missing one fails loudly below instead of sending the
 * string "undefined" as a credential and presenting as an unexplained 401.
 */

function required(name: string, value: string | undefined): string {
  if (!value || value.trim().length === 0) {
    throw new Error(
      `${name} is not set. Create React App inlines REACT_APP_* at BUILD time, so this has to be ` +
        `present when the bundle is built, not when it runs — set it in the build pipeline, or in ` +
        `.env.local for development. See .env.example.`,
    );
  }

  return value.trim();
}

export const config = {
  /** The gateway's client-scoped base, e.g. https://artemisapi.hr-flex.com/api/v1/clients */
  baseUrl: required("REACT_APP_API_BASE_URL", process.env.REACT_APP_API_BASE_URL),

  /** The portal's own gateway key. Public by construction; narrow by scope. */
  apiKey: required("REACT_APP_API_KEY", process.env.REACT_APP_API_KEY),
};
